export default __webpack_public_path__ + "static/media/Address.2d8bf894.png";